import type { ReactNode } from 'react'

export type StaffSegmentTab<T extends string> = {
  id: T
  label: string
  icon?: ReactNode
}

export function StaffSegmentTabs<T extends string>({
  tabs,
  activeTab,
  onChange,
  className = '',
}: {
  tabs: StaffSegmentTab<T>[]
  activeTab: T
  onChange: (tab: T) => void
  className?: string
}) {
  return (
    <div className={`inline-flex rounded-xl bg-slate-100 p-1 ${className}`.trim()} role="tablist">
      {tabs.map((tab) => {
        const active = tab.id === activeTab
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.id)}
            className={[
              'inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-medium transition',
              active ? 'bg-white text-blue-600 shadow-sm' : 'text-slate-600 hover:text-slate-900',
            ].join(' ')}
          >
            {tab.icon}
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}
